module.exports = __webpack_public_path__ + "2afd0c6e7cc4bad13312db88ed41507e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SecurePaymentStatement/images/img_plan_securepayment.svg
// module id = 1354
// module chunks = 3